import { IPostNode } from '../types/postsListing'
import BlogPostPreview from './blog-post-preview'

import { root, grid } from './blog-post-preview-grid.module.css'

interface BlogPostPreviewGridProps {
  nodes: IPostNode[]
}

function BlogPostPreviewGrid({ nodes }: BlogPostPreviewGridProps) {
  return (
    <div className={root}>
      <ul className={grid}>
        {nodes &&
          nodes.map((node) => (
            <li key={node.id}>
              <BlogPostPreview {...node} />
            </li>
          ))}
      </ul>
    </div>
  )
}

export default BlogPostPreviewGrid
